import {
  FirebaseStorage,
  getDownloadURL,
  listAll,
  ListResult,
  ref,
} from 'firebase/storage'

import { resolvePreferredStoragePath } from './storageFallbackResolver'

export const getUserDownloadURLWithLegacyFallback = (
  storage: FirebaseStorage,
  preferredPath: string,
  legacyPath: string,
) =>
  resolvePreferredStoragePath([preferredPath, legacyPath], (path) =>
    getDownloadURL(ref(storage, path)),
  )

export const listUserFolderWithLegacyFallback = (
  storage: FirebaseStorage,
  preferredPath: string,
  legacyPath: string,
) =>
  resolvePreferredStoragePath(
    [preferredPath, legacyPath],
    (path) => listAll(ref(storage, path)),
    (result: ListResult) =>
      result.items.length > 0 || result.prefixes.length > 0,
  )
